export default __webpack_public_path__ + "static/media/biodata-banner.9708a6a6.png";